import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TextNotAssigned = ({
  align = 'start',
  color = 'text-secondary ',
  className = '',
  size = 'xs',
  text = ''
}) => {
  return (
    <span className={`justify-${align} opacity-75 flex gap-1 items-center ${color} ${className}`}>
      <FontAwesomeIcon icon='exclamation-triangle' className={`text-${size}`} />
      <span className={`text-${size}`}>{text || 'Not assigned'}</span>
    </span>
  );
};
export default TextNotAssigned;
